import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ParticipatingcompaniesPageRoutingModule } from './participatingcompanies-routing.module';

import { NgSelectModule } from '@ng-select/ng-select';
import { DxDataGridModule } from 'devextreme-angular';
import { ParticipatingcompaniesPage } from './participatingcompanies.page';
import { ConfirmBoxDirectiveModule } from 'src/app/directives';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ParticipatingcompaniesPageRoutingModule,
		ReactiveFormsModule,
		NgSelectModule,
		DxDataGridModule,
		ConfirmBoxDirectiveModule,
	],
	declarations: [ParticipatingcompaniesPage],
})
export class ParticipatingcompaniesPageModule {}
